import { useEffect, useState } from "react";
import { Alert, Button, Loader, Select } from "@mantine/core";
import { useForm } from "@mantine/form";
import { IconAlertCircle } from "@tabler/icons-react";
import { useFetch } from "../../helpers/useFetch";

const getChildren = async () => {
  const res = await useFetch("/children/list");
  return res.data;
};

export default function FormStartModal({ context, id, innerProps }) {
  const [loading, setLoading] = useState(false);
  const [fetching, setFetching] = useState(true);
  const [error, setError] = useState(false);
  const [children, setChildren] = useState([]);
  const onSubmit = innerProps?.onSubmit;

  const form = useForm({
    initialValues: {
      child_id: "",
    },
  });

  useEffect(() => {
    getChildren()
      .then((res) => {
        setChildren(res);
        setFetching(false);
      })
      .catch((err) => {
        setError(err);
        setFetching(false);
      });
  }, []);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      await onSubmit(String(values.child_id));
      context.closeModal(id);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      {error && (
        <Alert
          icon={<IconAlertCircle size={16} stroke={1.5} />}
          title="Při požadavku nastala chyba."
          color="red"
          mb="md"
          mt="lg"
          withCloseButton
          closeButtonLabel="Zavřít upozornění"
          onClose={() => setError(false)}>
          {error}
        </Alert>
      )}
      {fetching ? (
        <div className="flex h-full w-full flex-col items-center justify-center py-8">
          <Loader />
        </div>
      ) : (
        <>
          <Select
            data={children.map((child) => ({
              label: `${child.firstName} ${child.lastName} (${child.team}, ${child.age} let)`,
              value: String(child.id),
            }))}
            mb="sm"
            required
            searchable
            hoverOnSearchChange={true}
            label="Dítě"
            placeholder="Vyber dítě..."
            {...form.getInputProps("child_id")}
          />

          <Button fullWidth type="submit" loading={loading} mt="lg">
            Inicializovat dotazník
          </Button>
        </>
      )}
    </form>
  );
}
